import React, { useMemo } from "react";
import { QCFinding } from "../../types/qcTypes";
import MarkdownRedlineContent from "./MarkdownRedlineContent";
import HtmlRedlineContent from "./HtmlRedlineContent";
import QCFindingsView from "./QCFindingsView";
import { isHtmlContent } from "./qcRedlineShared";

// Findings view for the panel-mode QC flows (integrated + quick_action), used
// by QCSectionPanel. Section content here may be HTML *or* markdown (the editor
// generates both), so the redline content is rendered through the matching
// branch -- HtmlRedlineContent or MarkdownRedlineContent. Everything else is
// the shared QCFindingsView. Headings are downgraded (panel header already
// shows the section title).

interface PanelQCResultsViewProps {
  findings: QCFinding[];
  sectionContent: string;
  sectionTitle: string;
  onAcceptFinding: (
    findingId: number,
    editedText?: string | null,
  ) => void | Promise<void>;
  onDeclineFinding: (findingId: number) => void | Promise<void>;
  onRevertFinding?: (findingId: number) => void | Promise<void>;
  onAcceptAll: () => void | Promise<void>;
  onDeclineAll: () => void | Promise<void>;
  onRevertAll?: () => void | Promise<void>;
  onSubmitFeedback?: (
    findingId: number,
    helpful: boolean,
  ) => void | Promise<void>;
  readOnly?: boolean;
}

const PanelQCResultsView: React.FC<PanelQCResultsViewProps> = ({
  findings,
  sectionContent,
  sectionTitle: _sectionTitle,
  ...rest
}) => {
  const useHtml = useMemo(
    () => isHtmlContent(sectionContent),
    [sectionContent],
  );
  const Content = useHtml ? HtmlRedlineContent : MarkdownRedlineContent;

  return (
    <QCFindingsView
      {...rest}
      findings={findings}
      renderContent={(components, className) => (
        <Content
          findings={findings}
          sectionContent={sectionContent}
          components={components}
          className={className}
        />
      )}
    />
  );
};

export default PanelQCResultsView;
